module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-8.0cb2781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-8.jpg
// module id = 9L3z
// module chunks = 1